// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".strong[data-v-48d8ef8b]{font-weight:700}.italic[data-v-48d8ef8b]{font-style:italic}.underline[data-v-48d8ef8b]{text-decoration:underline}.strike-through[data-v-48d8ef8b]{text-decoration:line-through}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
